'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MessageContent = require('./MessageContent');

var _MessageContent2 = _interopRequireDefault(_MessageContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Message = function Message(_ref) {
  var height = _ref.height,
      message = _ref.message,
      showMediaElement = _ref.showMediaElement,
      styles = _ref.styles,
      baseUrl = _ref.baseUrl;


  var arrow = message.showMedia ? _react2.default.createElement(
    'span',
    { className: 'arrow', onClick: showMediaElement, 'data-media-id': message.showMedia.mediaId, 'data-media-src': message.showMedia.elements[0].src, 'data-media-type': message.showMedia.elements[0].type, 'data-media-src-subtitles': message.showMedia.elements[0].srcSubtitles },
    _react2.default.createElement(
      'span',
      { className: 'meneo' },
      _react2.default.createElement('i', { className: 'icon-arrowright' })
    )
  ) : undefined;

  return _react2.default.createElement(
    'div',
    { className: 'messageContainer', 'data-message-id': message.messageId },
    message.avatar && _react2.default.createElement(Avatar, { src: message.avatar, styles: avatarStyles }),
    _react2.default.createElement(_MessageContent2.default, { height: height, message: message, baseUrl: baseUrl }),
    arrow
  );
};

Message.propTypes = {
  height: _react.PropTypes.number,
  message: _react.PropTypes.shape({
    message: _react.PropTypes.string,
    src: _react.PropTypes.string,
    inbound: _react.PropTypes.bool.isRequired,
    avatar: _react.PropTypes.string,
    backgroundColor: _react.PropTypes.string,
    color: _react.PropTypes.string
  }),
  showMediaElement: _react.PropTypes.func,
  styles: _react.PropTypes.object,
  baseUrl: _react.PropTypes.string
};

exports.default = Message;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/Message.js
// module id = 345
// module chunks = 0